<template>
  <div class="forgot-wrapper">
    <login-bar />

    <div class="forgot-container">
      <el-card class="forgot-card" shadow="always">
        <div class="forgot-title">找回密码</div>
        <p class="forgot-subtitle">验证身份以重置您的登录密码</p>

        <el-form ref="forgotForm" :model="userForgot" label-position="top" class="mt-20">
          <el-form-item label="邮箱/手机号">
            <div class="input-with-btn">
              <el-input
                  v-model="userForgot.principal"
                  prefix-icon="el-icon-mobile-phone"
                  placeholder="请输入邮箱或手机号"
                  clearable
              />
              <el-button
                  class="code-btn"
                  :disabled="isBtn"
                  @click="forgotVerifyCode"
              >
                {{ isBtn ? code + 's' : '获取验证码' }}
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="身份验证码">
            <el-input
                v-model="userForgot.verifyCode"
                prefix-icon="el-icon-chat-dot-round"
                placeholder="请输入 6 位数字验证码"
                clearable
            />
          </el-form-item>

          <el-form-item label="设置新密码">
            <el-input
                v-model="userForgot.newCredential"
                prefix-icon="el-icon-key"
                type="password"
                placeholder="请输入新密码"
                show-password
                clearable
            />
          </el-form-item>

          <el-form-item label="安全验证">
            <div class="captcha-box">
              <el-input
                  v-model="userForgot.captchaCode"
                  placeholder="图形验证码"
                  @keyup.enter.native="forgotBtn"
              />
              <el-image
                  class="captcha-img"
                  :src="captchaCode"
                  title="点击刷新"
                  @click="getCaptcha"
              />
            </div>
          </el-form-item>

          <div class="action-buttons">
            <el-button
                type="primary"
                class="submit-btn"
                :loading="isLoading"
                @click.native="forgotBtn"
            >
              提交重置
            </el-button>
            <div class="footer-link">
              <el-button type="text" icon="el-icon-back" @click="login">返回登录</el-button>
            </div>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import LoginBar from 'components/layout/LoginBar'

export default {
  name: 'Forgot',
  components: { LoginBar },
  mixins: [userMixin],
  created() {
    document.title = '找回密码'
    this.fetchPubkey(3)
  },
  methods: {
    login() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.forgot-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  flex-direction: column;
}

.forgot-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.forgot-card {
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
  border: none;
  padding: 10px 15px;
}

.forgot-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.forgot-subtitle {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin-bottom: 20px;
}

.mt-20 { margin-top: 20px; }

/* 布局辅助 */
.input-with-btn {
  display: flex;
  gap: 10px;
}

.code-btn {
  width: 120px;
  flex-shrink: 0;
}

.captcha-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-img {
  width: 110px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

/* 按钮区 */
.action-buttons {
  margin-top: 30px;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.footer-link {
  text-align: center;
  margin-top: 15px;
}

/* 移动端特殊处理 */
@media screen and (max-width: 480px) {
  .forgot-card {
    box-shadow: none;
    background: transparent;
  }
  .forgot-container {
    align-items: flex-start;
    padding-top: 40px;
  }
}

/* 覆盖 ElementUI 默认边距 */
/deep/ .el-form-item {
  margin-bottom: 18px;
}
/deep/ .el-form-item__label {
  line-height: 1;
  padding-bottom: 8px;
  font-weight: 500;
}
</style>
